import React, { ReactNode } from 'react';
import { Box, useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';

const HeaderContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  minHeight: '32px', // Changed from fixed height to min-height
  marginBottom: '16px',
  gap: '16px', // Add gap for spacing when items wrap
  flexWrap: 'wrap', // Allow wrapping on smaller screens
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '12px',
  },
}));

interface PageHeaderProps {
  children: ReactNode;
  action?: ReactNode;
}

export const PageHeader: React.FC<PageHeaderProps> = ({ children, action }) => {
  const theme = useTheme();

  return (
    <HeaderContainer>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        {/* Allow title to shrink and truncate if needed */}
        {children}
      </Box>
      {action && (
        <Box
          sx={{
            flexShrink: 0, // Prevent action from shrinking
            [theme.breakpoints.down('md')]: {
              width: '100%', // Full width on mobile
            },
          }}
        >
          {action}
        </Box>
      )}
    </HeaderContainer>
  );
};
